export enum AccountStatus {
  Active = 'active',
  AwaitingApproval = 'awaitingApproval',
  Suspended = 'suspended',
}
